module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/range-hood-61250cb336e23b0d6435f0661ed0eb1d.svg";